import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { getInitialFormState } from '../../../helpers/DisruptionAlert';
import { JourneyDirections } from '../../../constants/AppConstants';
import useStoreState from '../../../stores/useStoreState';
import CurrentTripStore from '../../../stores/CurrentTripStore';
import Order from '../../../records/Order';
import User from '../../../records/User';
import OrderTrip from '../../../records/order/Trip';
import DisruptionAlert from '../../../records/DisruptionAlert';
import AddRegularJourneyModal from '../../account/AddRegularJourneyModal';


const AlertBuilderModal = ({
    hideAlertCreationModal,
    journeyDirection,
    onAlertBuilderSubmit,
    order,
    orderTrip,
    outwardAlert,
    prefillFromSearch,
    user,
    isEditingAlert,
    editingAlert
}) => {
    const trip = useStoreState(CurrentTripStore);
    const isSeason = (orderTrip && orderTrip.isSeason()) || (prefillFromSearch && trip && trip.isSeason()) || false;

    const [initialSearch] = getInitialFormState(outwardAlert, order, orderTrip, trip, isSeason, false, journeyDirection, prefillFromSearch);

    const prepopulatedSearch = initialSearch;

    let presetWeekday = null;

    if (outwardAlert) {
        if (outwardAlert.daysOfWeek.includes('SATURDAY')) {
            presetWeekday = 'saturday';
        } else if (outwardAlert.daysOfWeek.includes('SUNDAY')) {
            presetWeekday = 'sunday';
        } else {
            presetWeekday = 'weekday';
        }
    }

    return (
        <AddRegularJourneyModal
            mode='ddm'
            prepopulatedSearch={prepopulatedSearch}
            remainingJourneys={Infinity} // let the API handle informing us that the user cannot add any more alerts
            setIsJourneyCardModalOpen={hideAlertCreationModal}
            setEditingJourney={_.noop}
            successCallback={({ alrt, err, success }) => onAlertBuilderSubmit({
                alrt,
                err,
                success,
            })}
            user={user}
            isEditingAlert={isEditingAlert}
            editingAlert={editingAlert}
            presetWeekday={presetWeekday}
        />
    );
};

AlertBuilderModal.propTypes = {
    hideAlertCreationModal: PropTypes.func,
    journeyDirection: PropTypes.oneOf(
        _.values(JourneyDirections),
    ),
    onAlertBuilderSubmit: PropTypes.func,
    order: PropTypes.instanceOf(Order),
    orderTrip: PropTypes.instanceOf(OrderTrip),
    outwardAlert: PropTypes.instanceOf(DisruptionAlert),
    prefillFromSearch: PropTypes.bool,
    user: PropTypes.instanceOf(User).isRequired,
    isEditingAlert: PropTypes.bool,
    editingAlert: PropTypes.instanceOf(DisruptionAlert),
};

export default AlertBuilderModal;
